<!--
   Created by qing on 2021/7/3
   Des:
-->
<template>

  <van-cell class="ry-form__item-qrcode">
    <template slot="title">
      <span class="title">{{current.title}}</span>
    </template>
    <template slot="label">

      <template v-if="current.fieldHint">
        <froalaView v-if="$store.getters.newRtf" v-model="current.fieldHint"></froalaView>
        <div
          v-else
          class="ql-editor"
          v-html="current.fieldHint">
        </div>
      </template>

      <div class="qrcode-container" :style="containerStyle">
<!--        <img :src="qrcodeImgSrc" alt="">-->
        <vue-qr
          :correctLevel="3"
          :text="qrcodeSrc"
          :size="Number(current.realWidth)"
          :margin="0"
        ></vue-qr>
      </div>
    </template>

  </van-cell>
</template>

<script>
  import {DEFAULT_VALUE__CUSTOM} from "../types";
  import {current} from './mixin'
  import QRCode from 'qrcode'
  export default {
    mixins: [current],
    data() {
      return {
        qrcodeImgSrc: ''
      }
    },
    created() {
      // QRCode.toDataURL(this.qrcodeSrc)
      //   .then(url => {
      //     this.qrcodeImgSrc = url
      //   })
      //   .catch(err => {
      //     console.error(err)
      //   })
    },
    computed: {

      qrcodeSrc() {
        if (this.current.defaultValue.defaultType === DEFAULT_VALUE__CUSTOM) {
          return this.current.defaultValue.customValue
        } else {
          return this.current.value
        }
      },

      containerStyle() {

        let justifyContent = 'center'

        return {
          display: 'flex',
          justifyContent
        }
      }
    },
    methods: {},
    watch: {
      'current.value'() {
        QRCode.toDataURL(this.qrcodeSrc)
          .then(url => {
            this.qrcodeImgSrc = url
          })
          .catch(err => {
            console.error(err)
          })
      }
    }
  }
</script>

<style lang="less">

  .ry-form__item-qrcode {

    .qrcode-container {
      width: 100%;

      img {
        width: 240px;
        height: 240px;
      }
    }
  }
</style>
